// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__3uB7F","description":"MealItem_description__2I46t","price":"MealItem_price__R2HwW"};